<template>
  <esg-base-chart height="200px">
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart height="175"
                ref="chart"
                type="bar"
                v-show="!loading"
                :options="chartOptions"
                :series="series"/>
  </esg-base-chart>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  props: {
    year: {
      type: Number
    },
    productFamily: {
      type: Object
    },
    product: {
      type: Object,
    },
  },
  components: {
    EsgBaseChart,
  },
  data() {
    return {
      loading: false,
      visible: false,
      categories: this.$store.getters['ghg/lifeCycleStages'],
      series: [],
      chartOptions: {
        chart: {
          type: "bar",
          stacked: true,
          stackType: "100%",
          toolbar: { show: false },
          zoom: { enabled: true },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.$emit('categorySelected', this.categories[config.seriesIndex])
            },
            dataPointMouseEnter: (event) => {
              event.target.style.cursor = "pointer"
            },
            mounted: (chart) => chart.windowResizeHandler()
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '30%',
          },
        },
        dataLabels: { enabled: true, },
        xaxis: {
          categories: [],
          labels: { show: false },
          axisBorder: { show: false },
        },
        yaxis: { show: false, },
        tooltip: {
          x: { show: false },
          y: {
            formatter: val => this.formatNumber(val, 2) + " tCO2"
          }
        },
        grid: { show: false },
        legend: {
          show: true,
          showForSingleSeries: true
        },
      },
    }
  },
  watch: {
    product: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchData()
      }
    },
    year: {
      handler() {
        this.fetchData();
      }
    },
  },
  methods: {
    async fetchData() {
      if (!this.product.productFamilyCode || !this.product.productCode || !this.product.name) return
      if (!this.year) return

      try {
        this.loading = true

        let args = [{
          years: [this.year],
          productFamilies: [this.product.productFamilyCode],
          products: [this.product.productCode],
          groupKeys: ['year', 'category']
        }];

        let data = new FormData();
        data.append('path', 'esg/lca/ghg_emission/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        // If there is no data, throw an error
        if (!response.data.data) {
          this.$emit('update:product', { productFamilyCode: null, productCode: null, name: null })
          this.$emit('update:productFamily', { code: null, name: null })
          this.$emit('noData')
          return
        }

        // Parse JSON data
        let chartData = JSON.parse(response.data.data)[0].data;

        // Group data based on LCA process and product name
        let seriesMap = new Map()
        for (let category of this.categories) {
          let ghg = chartData
              .filter(row => row.category === category.value)
              .map(row => row.values)
              .pop() || 0
          if (seriesMap.has(category.label)) {
            const series = seriesMap.get(category.label)
            series.push(ghg)
          } else {
            seriesMap.set(category.label, [ghg])
          }
        }

        // Set series and x axis labels
        this.series = Array.from(seriesMap, ([name, data]) => ({ name, data }))
      } catch (error) {
        this.loading = false
        await this.showError(error)
      } finally {
        this.loading = false
        this.refreshChart()
      }
    },
  }
}
</script>
